"use strict";
exports.__esModule = true;
exports.GdcFilterContext = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2021 GoodData Corporation
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
/**
 * @public
 */
var GdcFilterContext;
(function (GdcFilterContext) {
    function isDateFilter(filter) {
        return !isEmpty_1["default"](filter) && !!filter.dateFilter;
    }
    GdcFilterContext.isDateFilter = isDateFilter;
    function isAttributeFilter(filter) {
        return !isEmpty_1["default"](filter) && !!filter.attributeFilter;
    }
    GdcFilterContext.isAttributeFilter = isAttributeFilter;
    function isFilterContext(obj) {
        return !isEmpty_1["default"](obj) && obj.meta.category === "filterContext";
    }
    GdcFilterContext.isFilterContext = isFilterContext;
    function isWrappedFilterContext(obj) {
        // eslint-disable-next-line no-prototype-builtins
        return !isEmpty_1["default"](obj) && obj.hasOwnProperty("filterContext");
    }
    GdcFilterContext.isWrappedFilterContext = isWrappedFilterContext;
    function isTempFilterContext(obj) {
        return !!(!isEmpty_1["default"](obj) &&
            obj.created &&
            obj.uri &&
            obj.filters.every(function (x) { return isDateFilter(x) || isAttributeFilter(x); }));
    }
    GdcFilterContext.isTempFilterContext = isTempFilterContext;
    function isWrappedTempFilterContext(obj) {
        // eslint-disable-next-line no-prototype-builtins
        return !isEmpty_1["default"](obj) && obj.hasOwnProperty("tempFilterContext");
    }
    GdcFilterContext.isWrappedTempFilterContext = isWrappedTempFilterContext;
})(GdcFilterContext = exports.GdcFilterContext || (exports.GdcFilterContext = {}));
//# sourceMappingURL=GdcFilterContext.js.map